import React from "react";

import StyledContainer from "./styled";

type ContainerProps = {
  children?: any,
};

export const ScreenContainer = ({ children }: ContainerProps) => (
  <StyledContainer>{children}</StyledContainer>
);
